export function currentPathAndQuery() {
  const path = window.location.pathname;
  const query = window.location.search;
  return path + query;
}
